import { Button, Typography } from '@breetometer/components';
import { useModalApi } from 'BreetHooks';
import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';

const RequestNewPassword = () => {
	const navigate = useNavigate();

	const location = useLocation() as { state?: { email?: string } };

	const { closeModalDirect } = useModalApi();

	const [searchParams] = useSearchParams();

	const token = searchParams.get('token');

	const goToResetPassword = useCallback(async () => {
		await navigate('/reset-password', { state: { email: location.state?.email } });
		closeModalDirect('requestNewPassword');
	}, [navigate, location.state?.email, closeModalDirect]);

	return (
		<div className='newpasswordrequest'>
			<Typography
				as='h1'
				variant='big_header'
			>
				{!token ? 'Token Missing.' : 'Reset Link Invalid or Expired.'}
			</Typography>
			<Typography as='p'>Kindly request a new password reset link.</Typography>
			<Button
				label='Request New Link'
				variant='tertiary'
				onClick={goToResetPassword}
			/>
		</div>
	);
};

export default RequestNewPassword;
